import "./ResetPassword.css";
import Header from "./landingComponents/Header";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
const ResetPassword = () => {
  const [formData, setFormData] = useState({
    email: "",
  });

  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleClickEvent = async (e) => {
    e.preventDefault();

    if (formData.email == "") {
      Swal.fire({
        icon: "error",
        title: "Fill in all required fields",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "OK",
        style: {
          backgroundColor: "var(--color-black)",
        },
      });
      return;
    }
    try {
      // Make a POST request to the backend endpoint
      const response = await axios.post(
        "http://127.0.0.1:8000/user/forget-password",
        formData
      );
      // Handle response based on server's response
      if (response.status === 200) {
        navigate("/signin");
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed to send credientials",
          text: "Provide your Email again.",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "OK",
          style: {
            backgroundColor: "var(--color-black)",
          },
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Email not found",
        text: "Provide your valid email.",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "OK",
        style: {
          backgroundColor: "var(--color-black)",
        },
      });
    }
  };

  return (
    <div className="loginWrapper">
      <Header disappearNavlink={true} disappearRegister={true} />

      <div className="frame-top">
        <section className="frame-section">
          <div className="text-group">
            <h1 className="text2">Reset Password</h1>
            <div className="enter-your-email-container1">
              <p className="enter-your-email1">
                Enter your email address and we'll send you an email with new
                account password
              </p>
            </div>
          </div>
          <div className="email-group">
            <div className="email1">Email</div>
            <input
              className="email-input7"
              type="text"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
            />
          </div>
        </section>
        <button className="sign-in-button2" onClick={handleClickEvent}>
          <div className="button-shape">Reset</div>
        </button>
      </div>
    </div>
  );
};

export default ResetPassword;
